import { normalizeTimeValue } from '../../../../../common/ecxTimeUtils';

export const timeToMinutes = (timeValue) => {
    const normalized = normalizeTimeValue(timeValue);

    if (!normalized) {
        return null;
    }

    const [hours, minutes] = normalized.split(':').map(Number);

    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
        return null;
    }

    return hours * 60 + minutes;
};

export const validateEndAfterStart = (startTime, endTime, labels = {}) => {
    const {
        startLabel = 'Start',
        endLabel = 'End',
    } = labels;

    const startMinutes = timeToMinutes(startTime);
    const endMinutes = timeToMinutes(endTime);

    if (startMinutes === null || endMinutes === null) {
        return true;
    }

    if (endMinutes <= startMinutes) {
        return `${endLabel} time must be after ${startLabel.toLowerCase()} time`;
    }

    return true;
};

export const validateLunchRange = (lunchFrom, lunchTo) =>
    validateEndAfterStart(lunchFrom, lunchTo, {
        startLabel: 'Lunch start',
        endLabel: 'Lunch end',
    });

export const createEndTimeValidator = (getValues, isOffField = 'isOff') => (endTime) => {
    if (getValues(isOffField)) {
        return true;
    }

    return validateEndAfterStart(getValues('startTime'), endTime, {
        startLabel: 'Start',
        endLabel: 'End',
    });
};

export const createLunchToValidator = (getValues, isOffField = 'isOff') => (lunchTo) => {
    if (getValues(isOffField)) {
        return true;
    }

    const lunchFrom = getValues('lunchFrom');

    if (!lunchFrom && !lunchTo) {
        return true;
    }

    if (!lunchFrom || !lunchTo) {
        return 'Lunch start and end are required';
    }

    return validateLunchRange(lunchFrom, lunchTo);
};

export const createLunchFromValidator = (getValues, isOffField = 'isOff') => (lunchFrom) => {
    if (getValues(isOffField)) {
        return true;
    }

    const lunchTo = getValues('lunchTo');

    if (!lunchFrom && !lunchTo) {
        return true;
    }

    if (!lunchFrom || !lunchTo) {
        return 'Lunch start and end are required';
    }

    const result = validateLunchRange(lunchFrom, lunchTo);
    return result === true ? true : 'Lunch start must be before lunch end';
};
